<h1 style="text-align: center;">Notifications</h1>
<div style="display: flex; justify-content: center; align-items: center; gap: 10px; flex-direction: column;">
    @if (notifications.length === 0) {
        <mat-card style="width: 100%;">
            <mat-card-content style="text-align: center; padding: 2rem;">
                <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: var(--mat-sys-on-surface-variant);">notifications_none</mat-icon>
                <p style="margin-top: 1rem; color: var(--mat-sys-on-surface-variant);">No notifications yet</p>
            </mat-card-content>
        </mat-card>
    } @else {
        @for (notification of notifications; track notification.id) {
            <mat-card style="width: 100%;">
                <mat-card-content>
                    <div style="display: flex; gap: 1rem; align-items: flex-start;">
                        <mat-icon 
                            [style.color]="getNotificationColor(notification.type)"
                            style="font-size: 32px; width: 32px; height: 32px;">
                            {{ getNotificationIcon(notification.type) }}
                        </mat-icon>
                        <div style="flex: 1;">
                            <h3 style="margin: 0 0 0.5rem 0;">{{ notification.title }}</h3>
                            <p style="margin: 0 0 0.5rem 0; color: var(--mat-sys-on-surface-variant);">{{ notification.message }}</p>
                            @if (notification.staff_comment) {
                                <div style="
                                    margin-top: 0.75rem; 
                                    padding: 0.75rem; 
                                    background-color: var(--mat-sys-tertiary-container); 
                                    border-left: 3px solid var(--mat-sys-on-tertiary-container); 
                                    color: var(--mat-sys-on-tertiary-container);
                                    white-space: pre-wrap;">
                                    <strong>Staff Comment:</strong>
                                    <p style="margin: 0.5rem 0 0 0;">{{ notification.staff_comment }}</p>
                                </div>
                            }
                            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 1rem;">
                                <span style="color: var(--mat-sys-on-surface-variant); font-size: 0.875rem;">
                                    {{ formatDate(notification.created_at) }}
                                </span>
                                @if (notification.script_id) {
                                    <button mat-button (click)="navigateToScript(notification.script_id)">
                                        View Script
                                        <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin-left: 0.25rem;">arrow_forward</mat-icon>
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        }
    }
</div>

